import { QueryClient } from "@tanstack/react-query";

// Enhanced React Query configuration for 10K-20K users...
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry configuration
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors except 408 (timeout) and 429 (rate limit)
        if (
          error?.status >= 400 &&
          error?.status < 500 &&
          ![408, 429].includes(error?.status)
        ) {
          return false;
        }
        // Max 2 retries for other errors
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000), // Exponential backoff, max 10s

      // Cache configuration
      staleTime: 2 * 60 * 1000, // 2 minutes - data is fresh
      cacheTime: 10 * 60 * 1000, // 10 minutes - keep in cache

      // Performance optimizations
      refetchOnWindowFocus: false, // Prevent excessive refetching
      refetchOnReconnect: "always", // Refetch when back online
      refetchOnMount: true,

      // Network optimizations
      networkMode: "online", // Only run queries when online
    },
    mutations: {
      // Mutation configuration
      retry: 1, // Only retry mutations once
      retryDelay: 1000, // 1 second delay
      networkMode: "online",
    },
  },
});

// Global error handler
queryClient.setMutationDefaults(["update"], {
  onError: (error) => {
    console.error("Mutation error:", error);
    // TODO: Add toast notification or global error handling
  },
});

// Performance monitoring
if (process.env.NODE_ENV === "development") {
  queryClient.setQueryDefaults(["profile"], {
    onSuccess: (data) => {
      console.log("Profile query success:", data);
    },
    onError: (error) => {
      console.error("Profile query error:", error);
    },
  });
}

export default queryClient;
